import { lazy, ReactElement } from "react";
import PolicyIconContainer from "../../shared/PolicyIconContainer";
import { POLICY_ICON_PROPS } from "../../shared/policyIconConstants";

const DoubleOccupancyIcon = lazy(() => import("@Icons/DoubleOccupancyIcon"));
const RenewalIcon = lazy(() => import("@Icons/RenewalIcon"));
const EarlyCheckInIcon = lazy(() => import("@Icons/EarlyMoveInIcon"));
const RoomAssignmentIcon = lazy(() => import("@Icons/RoomAssignment"));
const RoomChangeIcon = lazy(() => import("@Icons/RoomChangeIcon"));
const SublettingIcon = lazy(() => import("@Icons/SublettingIcon"));
const TerminationIcon = lazy(() => import("@Icons/TerminationIcon"));
const SmokingIcon = lazy(() => import("@Icons/SmokingIcon"));
const CheckInIcon = lazy(() => import("@Icons/CheckInIcon"));
const CheckOutIcon = lazy(() => import("@Icons/CheckOutIcon"));
const RefundIcon = lazy(() => import("@Icons/RefundIcon"));
const PolicyFallbackIcon = lazy(() => import("@Icons/PolicyFallbackIcon"));
const PetsIcon = lazy(() => import("@Icons/PetsIcon"));
const ApplicationIcon = lazy(() => import("@Icons/ApplicationIcon"));
const GuestPolicyIcon = lazy(() => import("@Icons/GuestPolicyIcon"));
const QuietHoursIcon = lazy(() => import("@Icons/QuietHoursIcon"));
const RestrictedItemsIcon = lazy(() => import("@Icons/RestrictedItemsIcon"));
const WellbeingSafetyIcon = lazy(() => import("@Icons/WellbeingSafetyIcon"));
const MinimumAgeIcon = lazy(() => import("@Icons/MinimumAgeIcon"));
const DrugPolicyIcon = lazy(() => import("@Icons/DrugPolicyIcon"));
const StudentEligibilityIcon = lazy(() => import("@Icons/StudentEligibilityIcon"));

const normalizePolicyType = (policy_type: string) =>
  policy_type?.toLowerCase().replace(/&/g, "and").replace(/\s+/g, "_").trim();

const wrapPolicyIcon = (icon: ReactElement) => <PolicyIconContainer>{icon}</PolicyIconContainer>;

export const getDisplayIcon = (policy_type: string) => {
  switch (normalizePolicyType(policy_type)) {
    case "application":
      return wrapPolicyIcon(<ApplicationIcon {...POLICY_ICON_PROPS} />);
    case "pets":
      return wrapPolicyIcon(<PetsIcon {...POLICY_ICON_PROPS} />);
    case "double_occupancy":
      return wrapPolicyIcon(<DoubleOccupancyIcon {...POLICY_ICON_PROPS} />);
    case "renewal":
    case "renewal_policy":
      return wrapPolicyIcon(<RenewalIcon {...POLICY_ICON_PROPS} />);
    case "early_check_in":
    case "early_check_in_policy":
    case "early_move_in":
      return wrapPolicyIcon(<EarlyCheckInIcon {...POLICY_ICON_PROPS} />);
    case "refund":
      return wrapPolicyIcon(<RefundIcon {...POLICY_ICON_PROPS} />);
    case "room_assignment":
    case "room_allocation":
      return wrapPolicyIcon(<RoomAssignmentIcon {...POLICY_ICON_PROPS} />);
    case "room_change":
      return wrapPolicyIcon(<RoomChangeIcon {...POLICY_ICON_PROPS} />);
    case "subletting":
      return wrapPolicyIcon(<SublettingIcon {...POLICY_ICON_PROPS} />);
    case "termination":
      return wrapPolicyIcon(<TerminationIcon {...POLICY_ICON_PROPS} />);
    case "smoking":
      return wrapPolicyIcon(<SmokingIcon {...POLICY_ICON_PROPS} />);
    case "check_in_guide":
    case "check_in":
      return wrapPolicyIcon(<CheckInIcon {...POLICY_ICON_PROPS} />);
    case "check_out_guide":
      return wrapPolicyIcon(<CheckOutIcon {...POLICY_ICON_PROPS} />);
    case "guest_policy":
    case "guest_policies":
    case "guest_visits":
    case "guest":
      return wrapPolicyIcon(<GuestPolicyIcon {...POLICY_ICON_PROPS} />);
    case "quiet_hours":
    case "quiet_hour":
    case "quiet_hours_policy":
      return wrapPolicyIcon(<QuietHoursIcon {...POLICY_ICON_PROPS} />);
    case "restricted_items":
    case "restricted_item":
    case "restricted_items_policy":
      return wrapPolicyIcon(<RestrictedItemsIcon {...POLICY_ICON_PROPS} />);
    case "wellbeing_safety":
    case "wellbeing_and_safety":
    case "wellbeing_and_safety_policy":
      return wrapPolicyIcon(<WellbeingSafetyIcon {...POLICY_ICON_PROPS} />);
    case "minimum_age":
    case "min_age":
    case "minimum_age_policy":
      return wrapPolicyIcon(<MinimumAgeIcon {...POLICY_ICON_PROPS} />);
    case "drug_policy":
    case "drug_policies":
    case "drugs_policy":
    case "drugs_policies":
    case "drugs":
    case "drug":
      return wrapPolicyIcon(<DrugPolicyIcon {...POLICY_ICON_PROPS} />);
    case "student_eligibility":
    case "student_eligibility_policy":
      return wrapPolicyIcon(<StudentEligibilityIcon {...POLICY_ICON_PROPS} />);
    default:
      return wrapPolicyIcon(<PolicyFallbackIcon {...POLICY_ICON_PROPS} />);
  }
};

export default getDisplayIcon;
